<template>
  <div class="va-page-not-found justify--center position-relative pb-5">
    <div class="va-page-not-found__inner align--center">
      <slot name="image"/>
      <div class="va-page-not-found__title text--center mb-4">{{title}}</div>
      <div class="va-page-not-found__text px-4 text--center mb-4">
        <span>
          {{description}}
        </span>
      </div>
      <slot/>
      <va-button v-if="!withoutButton" :to="{ name: 'mainDashboard' }">{{$t('error.page404.backButton')}}</va-button>
    </div>
    <made-by-component/>
    <div class="va-page-not-found__wallpaper"/>
  </div>
</template>

<script>
import MadeByComponent from './MadeByComponent'

export default {
  name: 'va-page-not-found',
  components: {
    MadeByComponent,
  },
  props: {
    withoutButton: Boolean,
    title: String,
    description: String,
  },

}
</script>

<style lang="scss">
  .va-page-not-found {
    display: flex;
    @include media-breakpoint-down(sm) {
    }
    &__inner {
      display: flex;
      flex-direction: column;
      .va-icon-vuestic {
        width: 19rem;
        height: 2rem;
        margin-bottom: 13%;
      }
    }
    &__title {
      color: $white;
      font-size: 3rem;
      line-height: 1.25em;
      font-weight: 500;
      @include media-breakpoint-down(xs) {
        font-size: 1.5rem;
      }
    }
    &__text {
      margin-bottom: 2.5rem;
      color: $white;
    }
    &__wallpaper {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: transparent;
      background-image: url("../../../assets/images/TM.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      z-index: -1;
    }
  }
</style>
